import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/executive.svg";
var ExecutiveOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  ExecutiveOutline_default as default
};
